import { api } from '@fsd/shared/api';

export interface GetCentrifugoTokenResponse {
  token: string;
  channel: string;
}

export const getCentrifugoToken = async (): Promise<GetCentrifugoTokenResponse> => {
  const data = await api.get<GetCentrifugoTokenResponse>(
    '/api/v1/notification/realtime/token/'
  );
  return data;
}